import { ConfirmationDialog, MessagePanel } from '@dittolive/anvil'
import graphql from 'babel-plugin-relay/macro'
import TextBoxConfirmation from 'components/confirmation/TextBoxConfirmation'
import React, { useState } from 'react'
import { useLazyLoadQuery } from 'react-relay/hooks'

import { TransferAppConfirmationModalQuery } from './__generated__/TransferAppConfirmationModalQuery.graphql'

const query = graphql`
  query TransferAppConfirmationModalQuery($id: ID!) {
    viewer {
      appById(id: $id) {
        slug
      }
    }
  }
`

type Props = {
  /** True if the modal is open. */
  isOpen: boolean
  /** Callback for closing the modal */
  onClose: (transfer: boolean) => void
  /** ID of the app being transferred. */
  appId: string
  /** Destination tenant. */
  destination: string
  /** True if a transfer request id being processed. */
  isProcessing: boolean
}

/** Modal used to confirm that a request should be made to transfer an app to a different tenant. */
const TransferAppConfirmationModal: React.FC<Props> = ({
  isOpen,
  onClose,
  appId,
  destination,
  isProcessing,
}) => {
  const { viewer } = useLazyLoadQuery<TransferAppConfirmationModalQuery>(
    query,
    { id: appId },
  )

  const [isMatch, setIsMatch] = useState(false)
  const appSlug = viewer.appById?.slug

  return (
    <ConfirmationDialog
      open={isOpen}
      onCancel={() => onClose(false)}
      onConfirm={() => onClose(true)}
      title="Transfer database"
      confirmButtonText="Confirm"
      cancelButtonDisabled={isProcessing}
      confirmButtonDisabled={!isMatch || isProcessing}
      variant="warning"
      description="Are you sure you want to transfer your database?"
    >
      <MessagePanel
        variant="danger"
        message={() => (
          <>
            Once the transfer of database{' '}
            <span className="font-medium">{`"${appSlug}"`}</span> has been
            accepted by{' '}
            <span className="font-medium">{`"${destination}"`}</span> this
            action cannot be undone.
          </>
        )}
        className="mb-8"
      />
      <TextBoxConfirmation onMatch={setIsMatch} value={appSlug || ''} />
    </ConfirmationDialog>
  )
}

export default TransferAppConfirmationModal
